import { ObjectUtils } from "primereact/utils";
import React, { useContext, useEffect, useState } from "react";
import { useHref } from "react-router-dom";
import type { AppBreadcrumbProps, Breadcrumb } from "../types/types";
import { LayoutContext } from "./context/layoutcontext";

const AppBreadcrumb = (props: AppBreadcrumbProps) => {
  const href = useHref("");
  const [breadcrumb, setBreadcrumb] = useState<Breadcrumb | null>(null);
  const { breadcrumbs } = useContext(LayoutContext);

  useEffect(() => {
    const filteredBreadcrumbs = breadcrumbs?.find((crumb) => {
      if (crumb.to?.includes(":id")) {
        return href.includes(crumb.to.replace(":id", ""));
      } else {
        return crumb.to?.replace(/\/$/, "") === href.replace(/\/$/, "");
      }
    });
    setBreadcrumb(filteredBreadcrumbs ?? null);
  }, [breadcrumbs, href]);

  return (
    <div className={props.className}>
      <nav className="layout-breadcrumb">
        <ol>
          {ObjectUtils.isNotEmpty(breadcrumb?.labels)
            ? breadcrumb?.labels?.map((label, index) => {
                if (index !== 0) {
                  return (
                    <React.Fragment key={index}>
                      <li className="layout-breadcrumb-chevron"> /</li>
                      <li key={index}>{label}</li>
                    </React.Fragment>
                  );
                }
                return <li key={index}>{label}</li>;
              })
            : null}
        </ol>
      </nav>
    </div>
  );
};

export default AppBreadcrumb;
